import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import useBasketPrint from 'api/baskets/useBasketPrint/useBasketPrint';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect, useRef } from 'react';
import { Textfit } from 'react-textfit';
import { useReactToPrint } from 'react-to-print';

const BasketPrintModal = ({ open, handleClose, chosenPrintBasket }) => {
  const [getBasketItem, loading, basketItem] = useBasketPrint(
    chosenPrintBasket.id,
  );

  const refElement = useRef(null);
  const printRef = useRef(null);

  const reactToPrintFn = useReactToPrint({
    contentRef: refElement,
  });

  useEffect(() => {
    open && getBasketItem();
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      {loading ? (
        <SpinnerLoader />
      ) : (
        <>
          <DialogTitle sx={{ textAlign: 'center' }}>
            {chosenPrintBasket.title}
          </DialogTitle>

          <DialogContent>
            <Box
              ref={refElement}
              sx={{
                width: '6cm',
                height: '3cm',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                direction: 'ltr',
              }}
            >
              <TextsBox2>
                {chosenPrintBasket.title ? (
                  // <Typography
                  //   mb={0.5}
                  //   sx={{
                  //     color: '#000',
                  //     fontSize: `14px`,
                  //     overflowWrap: 'anywhere',
                  //     textAlign: 'center',
                  //     lineHeight: 1,
                  //   }}
                  // >
                  //   {chosenPrintBasket.title}
                  // </Typography>
                  <Box
                    sx={{
                      width: '2.6cm',
                      height: '1.5cm',
                      textAlign: 'center',
                      direction: 'rtl',
                      fontSize: '14px',
                    }}
                  >
                    <Textfit
                      mode="multi"
                      min={10}
                      max={14}
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {chosenPrintBasket.title}
                    </Textfit>
                  </Box>
                ) : null}
              </TextsBox2>
              <ImageQr src={basketItem.qrCode} alt={basketItem.display} />
            </Box>
          </DialogContent>

          <DialogActions
            sx={{ gap: 1, padding: 3, py: '10px', boxShadow: '3' }}
          >
            <LoadingButton
              variant="contained"
              color="primary"
              disabled={false}
              onClick={reactToPrintFn}
              // loading={printLoading || printsLoading}
            >
              پرینت
            </LoadingButton>
            <LoadingButton
              variant="contained"
              color="warning"
              onClick={() => {
                // setPrintData(null);
                // setPrintsData(null);
                handleClose();
              }}
            >
              بستن
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default BasketPrintModal;

const TextsBox2 = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transform: 'rotate(270deg)',
  marginBottom: '5px',
});

const ImageQr = styled.img`
  width: 2.85cm;
`;
